import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/i18n";

const Word = ({ word, range, progress }) => {
  const opacity = useTransform(progress, range, [0.18, 1]);
  return <motion.span style={{ opacity }} className="inline-block mr-[0.25em]">{word}</motion.span>;
};

export const Manifesto = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = t.manifesto.split(" ");
  return (
    <section ref={ref} data-testid="manifesto-section" className="relative py-28 lg:py-40 overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(135deg,#450A0A_0%,#180505_45%,#050505_100%)] opacity-70" />
      <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <p className="font-display font-extrabold uppercase text-white text-4xl sm:text-6xl lg:text-[6.5rem] leading-[0.95] tracking-tight max-w-6xl">
          <span className="text-red-500">“</span>
          {words.map((w, i) => (
            <Word key={`${w}-${i}`} word={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
          ))}
        </p>
        <p className="mt-10 font-mono text-xs uppercase tracking-[0.3em] text-zinc-400">— Armat Defense</p>
      </div>
    </section>
  );
};
